const pauseVimeoOutOfViewport = () => {
	// Select the iframe element
	var iframe = document.querySelector('iframe');

	// Initialize the Vimeo player
	var player = new Vimeo.Player(iframe);

	// IntersectionObserver to detect if the player is in or out of the viewport
	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					player.pause();
				}
			});
		},
		{
			threshold: 0.1, // Trigger when at least 10% of the player is visible
		}
	);

	// Observe the iframe element
	observer.observe(iframe);

	const videoPlayer = document.querySelectorAll('.service-video');

	const videoCover = document.querySelector('.missCom__vidImageCont');
	videoPlayer.forEach((item) => {
		item.addEventListener('click', function () {
			if (iframe.classList.contains('playing')) {
				iframe.classList.remove('playing');
				player.pause();
			} else {
				iframe.classList.add('playing');
				videoCover.classList.add('missCom__vidImageCont--hide');
				player.play();
			}
		});
	});
};

export default pauseVimeoOutOfViewport;
